import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import {  LargeButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonFlateButton from "../Common/CommonFlatButton";
import { FLAT_LARGE_BUTTONS, FLAT_LARGE_BUTTONS_LIST } from "../../../../Data/Buttons/FlatStyle";

const FlatLargeButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={LargeButton} span={FLAT_LARGE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn size="lg" color="primary" className="btn-square" id="Tooltip-8">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-8" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-square btn-primary btn-lg</ToolTip>
          {FLAT_LARGE_BUTTONS_LIST.map((data, index) => (
            <CommonFlateButton key={index} item={data} size="lg" />
          ))}
        </CardBody>
      </Card>
    );
};

export default FlatLargeButtons;
